import { useEffect, useState } from 'react'
import { useMutation } from '@apollo/client'
import useLoggedInUser from '~/hooks/useLoggedInUser'
import { STORE_REFERRAL_CODE } from '~/graphql/mutations/storeReferralCode'
import { deleteCookie, getCookie } from 'cookies-next'

const REFERRAL_COOKIE_NAME = 'pendingReferral'

const Referrals = () => {
  const { loggedInUser } = useLoggedInUser()
  const referralCookie = getCookie(REFERRAL_COOKIE_NAME)
  const referralData = referralCookie ? JSON.parse(referralCookie) : null
  const [storeReferralCode] = useMutation(STORE_REFERRAL_CODE)
  const [referralStored, setReferralStored] = useState(false)

  useEffect(() => {
    if (referralStored) return
    if (!referralData || !loggedInUser) return

    const storeReferral = async () => {
      setReferralStored(true)

      try {
        deleteCookie('pendingReferral')
        await storeReferralCode({
          variables: {
            input: {
              sourceEventId: referralData.eventId,
              referrer: referralData.referral,
              code: referralData.referral_uid,
            },
          },
        })

        setReferralStored(false)
      } catch (error) {}
    }

    storeReferral()
  }, [referralData, loggedInUser, storeReferralCode, referralStored])

  return null
}

export default Referrals
